import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-apollo';

import Button from '../../../../../../components/global/Button';
import { getErrorString } from '../../../../../../util/normalize-errors';
import { AccountBlockedAccountCreate } from '../../../../../../graphql/mutations/account';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    username: PropTypes.string,
  }),
  onAccountBlockCreated: PropTypes.func,
  onClose: PropTypes.func,
};

const AccountBlock = ({ account, onAccountBlockCreated, onClose }) => {
  const [accountBlockedAccountCreate] = useMutation(
    AccountBlockedAccountCreate,
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onAccountBlock = async () => {
    if (loading) {
      return;
    }

    try {
      setLoading(true);
      await accountBlockedAccountCreate({
        variables: {
          input: {
            blocked_account_id: account.id,
          },
        },
      });
      setLoading(false);
      onClose?.();
      onAccountBlockCreated?.();
    } catch (err) {
      setError(getErrorString(err));
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="text-center">
          Block <span className="text-primary">@{account.username}</span>?{' '}
        </h3>

        <p className="text-center">
          <span className="text-primary">@{account.username}</span> will no
          longer be able to see or search your profile and events.
        </p>
      </div>

      {error && <p className="text-danger text-center">{error}</p>}

      <div className="col-12 col-md-6">
        <Button
          btnSize="lg"
          btnOutline
          btnBlock
          onClick={onClose}
          disabled={loading}
          className="mt-1"
        >
          Go Back
        </Button>
      </div>
      <div className="col-12 col-md-6">
        <Button
          btnSize="lg"
          btnOutline
          onClick={onAccountBlock}
          btnStyle="danger"
          disabled={loading}
          btnBlock
          className="mt-1"
        >
          Block user
        </Button>
      </div>
    </div>
  );
};

AccountBlock.propTypes = propTypes;

export default AccountBlock;
